export default {
  isInViewport: (el) => {
    const elRect = el[0].getBoundingClientRect();
    return (elRect.top >= 0) && (elRect.bottom <= window.innerHeight);
  }
};



// WEBPACK FOOTER //
// ./js/helpers.js